<button
  class="btn btn-primary"
  [disabled]="getProductsRequiringReplenishment().length <= 0"
  (click)="createReplenishment()"
  translate
>
  CREATE_REPLENISHMENT
</button>
